// Getter
export const GETTERS_EXTRACTS = "GETTERS_EXTRACTS";
export const GETTERS_EXTRACTS_TYPE = "GETTERS_EXTRACTS_TYPE";
export const GETTERS_EXTRACT_NOTIFICATION = "GETTERS_EXTRACT_NOTIFICATION";

// action
export const ACTION_GET_EXTRACTS = "ACTION_GET_EXTRACTS";
export const ACTION_DOWNLOAD_EXTRACT = "ACTION_DOWNLOAD_EXTRACT";
export const ACTION_GET_EXTRACT_TYPES = "ACTION_GET_EXTRACT_TYPES";
export const ACTION_REQUEST_GENERATE_REPORTS = "ACTION_REQUEST_GENERATE_REPORTS";
export const ACTION_GET_EXTRACT_NOTIFICATION = "ACTION_GET_EXTRACT_NOTIFICATION";

// Mutation
export const MUTATION_SET_EXTRACTS = "MUTATION_SET_EXTRACTS";
export const MUTATION_SET_EXTRACT_TYPES = "MUTATION_SET_EXTRACT_TYPES";
export const MUTATION_SET_EXTRACT_NOTIFICATION = "MUTATION_SET_EXTRACT_NOTIFICATION";


// WEBPACK FOOTER //
// ./src/store/modules/extracts/constants.js